import React from 'react';
import classes from '../styles/style.module.css';

const HubbleButton = ({children,...rest}) => {
  return (
    <button className={classes.hubbleButton} {...rest}>{children}</button>
  )
}

export default HubbleButton